import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { PageFeatureConfigSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { GoogleMapPageConfig, GoogleMapSiteConfig } from './types'
import { name } from './symbols'
import { IUrlHistoryManager, UrlHistoryManagerSymbol } from 'feature-router'
import { IComponentPropsExtender } from 'feature-components'
import { GoogleMapProps, Location } from '@wix/thunderbolt-components'

const googleMapFactory = (
	{ externalBaseUrl }: GoogleMapSiteConfig,
	{ componentsIds }: GoogleMapPageConfig,
	urlHistoryManager: IUrlHistoryManager
): IComponentPropsExtender<GoogleMapProps, GoogleMapProps> => {
	return {
		componentTypes: ['GoogleMap'],
		getExtendedProps: (compId, googleMapCompProps) => {
			if (!componentsIds[compId]) {
				return null
			}

			const currentParsedUrl = urlHistoryManager.getParsedUrl()
			const updatedLocations = googleMapCompProps.mapData.locations.map((location: Location) => {
				const locationHref = location.locationLinkAttributes?.href || ''
				const isRelativeLocationLink = locationHref.startsWith('./')
				if (isRelativeLocationLink) {
					const isHomePageUrl = locationHref === './'
					const urlToParse = isHomePageUrl ? externalBaseUrl : locationHref
					const fullUrl = new URL(urlToParse, `${externalBaseUrl}/`)

					return {
						...location,
						locationLinkAttributes: {
							...location.locationLinkAttributes,
							href: `${fullUrl.href}${currentParsedUrl.search}`,
						},
					}
				}

				return location
			})

			return {
				...googleMapCompProps,
				mapData: {
					...googleMapCompProps.mapData,
					locations: updatedLocations,
				},
			}
		},
	}
}

export const GoogleMap = withDependencies(
	[named(SiteFeatureConfigSymbol, name), named(PageFeatureConfigSymbol, name), UrlHistoryManagerSymbol],
	googleMapFactory
)
